import { Tooltip } from '@roo/roo';
import { Col, Row } from '@roo/roo/Grid';
import * as React from 'react';
import utils from '@/utils/utils';
import {
    ApprovedStatusEnum,
    ApprovedStatusZH,
    IInfoProps,
    OnlineStatusEnum,
    PunishStatusEnum,
    PunishStatusZH,
    ServiceStatusEnum,
} from '../api';

const Index = (props: IInfoProps) => {
    const { service } = props;

    const getShadowTxt = () => {
        let txt = '';
        if (service.approvedStatus !== ApprovedStatusEnum.passed) {
            // 审核状态非正常
            txt = ApprovedStatusZH[service.approvedStatus];
        } else if (service.onlineStatus === OnlineStatusEnum.offline) {
            // 已下架
            txt = '已下架';
        } else if (service.punishStatus !== PunishStatusEnum.normal) {
            // 有处罚状态
            txt = PunishStatusZH[service.punishStatus];
            if (service.punishStatus === PunishStatusEnum.rest) {
                txt += `${service.pauseDay}天`;
            }
        }
        return txt;
    };

    const getCities = () => service.cities.map(e => e.cityName).join(',');

    return (
        <Row>
            <div className="logo">
                {service.serviceStatus === ServiceStatusEnum.unShow ? (
                    <>
                        <div className="shadow-txt">{getShadowTxt()}</div>
                        <div className="shadow" />
                    </>
                ) : null}
                <img src={service.logo} alt="" />
            </div>
            <Col span={6}>
                <div className="logo-info">
                    <Row>
                        <div className="title">
                            <span style={{ verticalAlign: 'middle' }}>{service.serviceName}</span>
                            {service.isNewItem === 1 ? (
                                <span style={{ verticalAlign: 'middle' }}>
                                    <span className="server-new-tip">
                                        <span className="text-new">新</span>
                                        <span className="text-other">服务7天保护中</span>
                                        <Tooltip
                                            content={`推广保护期截至：${
                                                utils.timestampToMinutes(service.newItemPassTime)
                                                    .date
                                            }`}
                                            placement="bottom"
                                            effect="light"
                                        >
                                            <span className="new-tip-icon">?</span>
                                        </Tooltip>
                                    </span>
                                </span>
                            ) : null}
                        </div>
                    </Row>
                    <Row>
                        <div className="tags">
                            {service.tags.map(e => (
                                <div className="tag">{e}</div>
                            ))}
                        </div>
                    </Row>
                    <Row>
                        <Tooltip content={getCities()} placement="bottom" effect="light">
                            <div className="cities">{getCities()}</div>
                        </Tooltip>
                    </Row>
                </div>
            </Col>
        </Row>
    );
};

export default Index;
